<template>
  <div class="mfa-page overflow-x-hide overflow-y-hide">
    <div class="container no-padding">
      <div class="row no-margin">
        <div class="col-md-12" :style="{ 'min-height': dyn_height }">
          <HeaderLogo :page-type="'3'" :light_logo="true" />

          <div
            class="row no-padding main-body h-100"
            :style="{ height: windowHeight }"
          >
            <div class="col-md-12 flex-container">
              <BrandPattern page="MFASelection" />
            </div>
          </div>
        </div>

        <!-- Sign In Modal -->
        <div
          id="mfaModal"
          ref="mfaModal"
          class="modal fade mfa-modal show tw-block"
          role="dialog"
          aria-labelledby="mfaModalLabel"
          data-backdrop="false"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <mfaSelectionContent
                :multiple-options="true"
                :from-login="true"
                @update:click:authen="handleByAuthen"
                @update:click:passkey="handleByPasskey"
                @close="handleCloseModal"
              >
              </mfaSelectionContent>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from "vue";
import $ from "jquery";
import HeaderLogo from "@/components/common/headerLogo.vue";
import BrandPattern from "@/components/prospect/brandPattern/brandPattern.vue";
import store from "@/store";
import router from "@/router";
import { UserRoute, homeRoute } from "@/services/apiRoutes/routes";
import { startRegistration } from "@simplewebauthn/browser";
import Utils from "@/utils/utilities";
import userService from "@/services/user/userService";
import mfaSelectionContent from "@/components/user/mfaSelectionContent.vue";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";

let dyn_height = ref("");
let windowHeight = ref("");
const mfaModal = ref<null>(null);
onMounted(() => {
  nextTick(function () {
    window.addEventListener("resize", onResize);
    onResize();
  });
  document.getElementById("mfaModal")?.classList.add("show");

  const body = $("body");
  if (!body.hasClass("page-opacity")) {
    body.addClass("page-opacity page-bg");
  }
});

const onResize = () => {
  dyn_height.value = (window.innerHeight + "px") as string;
  windowHeight.value = "" + window.innerHeight + "px !important ";
};

const handleByAuthen = () => {
  store.dispatch("User/setPreSession");
  router.push(UserRoute.twoStepAuthenticationSetup);
};

const handleByPasskey = () => {
  webAuthnLogin();
};

const webAuthnLogin = () => {
  userService.mfaWebauthnRegister().then(async (res: any) => {
    try {
      const challengeResponse = res.data.data;
      const attResp = await startRegistration(challengeResponse);
      userService.mfaWebauthnVerifyRegister(attResp).then(async (res: any) => {
        await Utils.afterLoginActions(res.data.data);
        router.push(homeRoute.welcomePage);
      });
    } catch (err: any) {
      showError(err.message);
    }
  });
};

const handleCloseModal = () => {
  router.push(UserRoute.login);
};

const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};
</script>

<style lang="scss" scoped>
.mfa-page {
  background: #0345bd;

  .modal {
    pointer-events: none;
  }
  .mfa-modal {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 50%;
    pointer-events: none;
    top: 50%;
    transform: translate(-50%, -50%);
    .form-control:focus {
      box-shadow: none;
    }
    .form-control::placeholder {
      color: #b7b7b7;
      font-size: 22px;
    }
    .modal-dialog {
      transition: none;
      max-width: 630px !important;
    }
    .modal-content {
      box-shadow: 2px 0px 20px rgba(33, 31, 88, 0.1);
      border-radius: 6px;
      border: none;
    }
    .show-password {
      align-items: center;
      .show-password-label {
        margin: 0px;
      }
    }
  }
  .forgot-text-button {
    cursor: pointer;
  }
}
</style>
